export default __webpack_public_path__ + "static/media/header-onboarding-3.8485685e.svg";